import cn from 'classnames';
import calculatePrice, { calculateComparePrice } from 'helpers/calculatePrice';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import {
  JsonParam,
  StringParam,
  useQueryParam,
  withDefault,
} from 'use-query-params';
import { usePcConfigurator } from 'utils/PcConfiguratorContext';
import { STEPS } from '../constants';
import { STEPS_FOUR_STAGES } from '../constants_four_stages';
import PcModelAddToCart from '../PcModelAddToCart';
import PcModelDelayModal from '../PcModelDelayModal';
import PcModelOverviewSpecs from '../PcModelOverviewSpecs';
import PcModelRemovedItemModal from '../PcModelRemovedItemModal';
import PcModelValidationModal from '../PcModelValidationModal';
import styles from './styles';

const PcModelStepsNext = ({ productType, hideMobile, margins }) => {
  let UPDATED_STEPS = STEPS;

  const { options, pcModel, currentOptions, errors } = usePcConfigurator();
  const optionsFourStages = ['build', 'ultra-labs', 'accessories (new)'];
  let isInArray = false;

  if (options?.length != 0) {
    isInArray = optionsFourStages.includes(options[0].group_step_new);
    if (isInArray) {
      UPDATED_STEPS = STEPS_FOUR_STAGES;
    } else {
      UPDATED_STEPS = STEPS;
    }
  }

  const [currentStep, setCurrentStep] = useQueryParam(
    'step',
    withDefault(StringParam, UPDATED_STEPS[0]),
  );

  const price = calculatePrice(currentOptions, pcModel.price);

  const [currentSelections] = useQueryParam('selections', JsonParam);
  const removedOptions = [];
  if (currentSelections) {
    Object.keys(currentSelections).forEach((current) => {
      const selectedOption = currentOptions.find(
        (o) => o.group_type === current,
      );
      if (!selectedOption) {
        removedOptions.push(current);
      }
    });
  }

  const [currentIndex, setCurrentIndex] = useState(null);

  const findStepIndex = (step) =>
    UPDATED_STEPS.findIndex((item) => item === step);

  useEffect(() => {
    setCurrentIndex(findStepIndex(currentStep));
  }, [currentStep]);

  const nextIndex = currentIndex + 1;

  const handleClick = () => {
    setCurrentStep(UPDATED_STEPS[nextIndex]);
    document.getElementById('pc-configurator').scrollIntoView();
  };

  const comparePrice = calculateComparePrice(
    currentOptions,
    pcModel.compare_at,
  );

  return (
    <div className="step">
      <div className={cn('wrapper step-container', { hideMobile })}>
        <div className=" step-wrapper">
          <div className="pc-info">
            <div className="pc-title">Your {pcModel.model_title}</div>
            <div className="pc-config">
              {/* <span className="as-config">As configured</span> */}
              <span>
                <PcModelOverviewSpecs />
              </span>
            </div>
          </div>
          <div className="amount">
            <div className="money">RM {price}</div>
            <div className="money-description">
              <div className="money-compare">
                {parseFloat(comparePrice).toLocaleString()}
              </div>
              <div className="money-save">
                You save RM {parseFloat(comparePrice) - parseFloat(price)}
              </div>
            </div>
          </div>
          {(isInArray ? currentIndex === 3 : currentIndex === 4) ? (
            <PcModelAddToCart
              pcModel={pcModel}
              options={currentOptions}
              price={price}
              comparePrice={comparePrice}
              disabled={errors?.length > 0 || removedOptions?.length > 0}
              productType={productType}
              customProductLink={global?.window?.location?.href}
              displayVariant="step"
              errors={errors}
              removedOptions={removedOptions}
            />
          ) : (
            <div
              className={cn('button-container', {
                'button-margins': margins,
              })}
            >
              <button className="step-next" type="button" onClick={handleClick}>
                <span className="text">
                  <span> Continue to </span>
                  <span id="next-step">
                    {UPDATED_STEPS[nextIndex] == 'accessoriesnew'
                      ? 'accessories'
                      : UPDATED_STEPS[nextIndex]}
                  </span>
                </span>
                <span className="icon">
                  <Image
                    draggable={false}
                    src="/icons/icon_arrow.svg"
                    height="20"
                    width="20"
                    alt="arrow_icon"
                  />
                </span>
              </button>
            </div>
          )}
          <div className="alert-icon-container">
            <PcModelValidationModal errors={errors} variant="icon" />
            <PcModelDelayModal currentOptions={currentOptions} variant="icon" />
            <PcModelRemovedItemModal
              variant="icon"
              currentOptions={currentOptions}
              removedOptions={removedOptions}
            />
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
      <style jsx>
        {`
          @media (max-width: 1024px) {
            .hideMobile {
              display: none;
            }
          }
        `}
      </style>
    </div>
  );
};

PcModelStepsNext.propTypes = {
  productType: PropTypes.string,
  hideMobile: PropTypes.bool,
  margins: PropTypes.bool,
};

PcModelStepsNext.defaultProps = {
  productType: null,
  hideMobile: false,
  margins: false,
};

export default PcModelStepsNext;
